import { ProductType } from '@tink/core/src/types';
import { ConfigurationFeatureFlag, ConfigurationModel } from '@tink/config/src/tinkLinkConfig';
import { ProductDimension, ProductDimensionPay } from '../../models/product';
import { RefreshableItem } from '../../models/refreshableItem';

// AIS + PIS ONLY
const defaultRefreshableItemsForPayments = [
  RefreshableItem.CHECKING_ACCOUNTS,
  RefreshableItem.SAVING_ACCOUNTS,
  RefreshableItem.TRANSFER_DESTINATIONS,
];
// Fraud Prevention requires Transactions along with regular refreshableItems
const refreshableItemsForFraudPrevention = [
  RefreshableItem.CHECKING_ACCOUNTS,
  RefreshableItem.SAVING_ACCOUNTS,
  RefreshableItem.TRANSFER_DESTINATIONS,
  RefreshableItem.SAVING_TRANSACTIONS,
  RefreshableItem.CHECKING_TRANSACTIONS,
];

export const isFraudPreventionEnabled = (
  productType: ProductType,
  productDimension: ProductDimension,
  config: Pick<ConfigurationModel, 'featureFlags'>
) =>
  productType === ProductType.PAY &&
  productDimension === ProductDimensionPay.DIRECT &&
  config.featureFlags.includes(ConfigurationFeatureFlag.PAYMENT_FRAUD_PREVENTION_BUNDLE);

export const getPaymentRefreshableItems = (
  productType: ProductType,
  productDimension: ProductDimension,
  config: ConfigurationModel
) => {
  if (isFraudPreventionEnabled(productType, productDimension, config)) {
    return refreshableItemsForFraudPrevention;
  }

  return defaultRefreshableItemsForPayments;
};
